import React from 'react'
import PropTypes from 'prop-types'
import { useWillConstrain } from '@morningtrain/react-filters'
import useDepartmentId from 'support/hooks/use-department-id'

function SelectedDepartmentFilter ({ name }) {
  const [departmentId] = useDepartmentId()

  useWillConstrain(name, departmentId)

  return null
}

SelectedDepartmentFilter.defaultProps = {
  name: 'department'
}

SelectedDepartmentFilter.propTypes = {
  name: PropTypes.string
}

export default SelectedDepartmentFilter
